// Ported from platform-legacy/readonly/platform/components/DesignSystemSummary.js
// v3 → v3.14: extend → extends. No props: wrapper to flatten.
// TODO: verify SummaryComponent dependency in current sharedLibraries chain.
export const DesignSystemSummary = {
  extends: 'Group',
  Title: {
    margin: '- - A',
    text: '{{ editor.ds.title | polyglot }}'
  },
  Box: {
    columns: '14.3rem',
    gap: 'B1',
    style: {
      width: '-webkit-fill-available'
    },
    childExtends: 'SummaryComponent',
    children: (el, s) => el.call('applyDesignSystemSummaryCollection'),
    childrenAs: 'state'
  }
}
